import React from 'react';

function WishIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      className={className}
    >
      <g className="hover">
        <polygon
          fill="#FFE500"
          points="11.9,1.5 15.5,8.4 23.5,9.5 17.7,14.9 19.1,22.5 11.9,18.9 4.8,22.5 6.2,14.9 0.4,9.5 8.4,8.4"
        />
      </g>
      <g>
        <path
          fill="#0E0E11"
          d="M24,9.4C23.9,9.2,23.8,9,23.6,9l-7.7-1.1l-3.4-6.7c-0.2-0.3-0.7-0.3-0.9,0L8.1,7.9L0.4,9C0.2,9,0.1,9.2,0,9.4C0,9.5,0,9.7,0.2,9.9l5.6,5.2l-1.3,7.3c0,0.2,0,0.4,0.2,0.5c0.2,0.1,0.4,0.1,0.5,0l6.9-3.5l6.9,3.5C19,23,19,23,19.1,23c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.2-0.3,0.2-0.5l-1.3-7.3l5.6-5.2C24,9.7,24,9.5,24,9.4z M17.4,14.5c-0.1,0.1-0.2,0.3-0.2,0.5l1.2,6.6l-6.2-3.1c-0.1,0-0.1-0.1-0.2-0.1s-0.2,0-0.2,0.1l-6.2,3.1L6.7,15c0-0.2,0-0.3-0.2-0.5l-5-4.7l6.9-1c0.2,0,0.3-0.1,0.4-0.3L12,2.6l3.1,6.1c0.1,0.1,0.2,0.2,0.4,0.3l6.9,1L17.4,14.5z"
        />
        <path
          fill="#0E0E11"
          d="M12.4,7.5c-0.2-0.1-0.5,0-0.7,0.2l-1.6,3.2l-2.2,0.3c-0.3,0-0.5,0.3-0.4,0.6c0,0.3,0.2,0.4,0.5,0.4c0,0,0,0,0.1,0l2.4-0.3c0.2,0,0.3-0.1,0.4-0.3l1.8-3.4C12.8,8,12.7,7.7,12.4,7.5z"
        />
      </g>
    </svg>
  );
}

export default WishIcon;
